import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    FlyFreelyConstants,
    MissionDetailsDto
} from '@flyfreely-portal-ui/flyfreely';

interface BasicMissionDetails {
    name: string;
    isDummy: boolean;
    status: MissionDetailsDto.Status;
}

@Pipe({ name: 'formatMissionStatusIcon' })
export class FormatMissionStatusIconPipe implements PipeTransform {
    constructor(
        private sanitizer: DomSanitizer,
        private constants: FlyFreelyConstants
    ) {}

    transform(mission: BasicMissionDetails, returnSafeHtml = true) {
        if (mission === null) {
            return null;
        }

        const statusHtml = this.createHtml(mission);

        // if (returnSafeHtml) {
        //    return this.sanitizer.bypassSecurityTrustHtml(statusHtml);
        // } else {
        return statusHtml;
        // }
    }

    createHtml(mission: BasicMissionDetails) {
        const statusColour = this.findStatusColour(mission.status);
        if (mission.isDummy) {
            return `
            <div class="status-icon-block">
                <div class="status-icon">
                    <div>
                        <img src="${this.constants.IMG_URL}/icons/dummy-icon.png" />
                    </div>
                </div>
                <div class="name-with-icon">
                ${mission.name}
                </div>
            </div>`;
        } else {
            return `
            <div class="status-icon-block">
                <div class="status-icon">
                    <div class="status-icon-${statusColour}"></div>
                </div>
                <div class="name-with-icon">
                ${mission.name}
                </div>
            </div>`;
        }
    }

    findStatusColour(status: MissionDetailsDto.Status) {
        switch (status) {
            case MissionDetailsDto.Status.READY_TO_FLY:
            // fallthrough
            case MissionDetailsDto.Status.ACTIVATED:
            // fallthrough
            case MissionDetailsDto.Status.PREPARED:
                return 'green';

            case MissionDetailsDto.Status.ON_SITE:
            // fallthrough
            case MissionDetailsDto.Status.FLYING:
            // fallthrough
            case MissionDetailsDto.Status.DONE_FLYING:
            // fallthrough
            case MissionDetailsDto.Status.AWAITING_SYNC:
                return 'yellow';

            case MissionDetailsDto.Status.DRAFT:
                return 'grey';

            case MissionDetailsDto.Status.CANCELLED:
                return 'red';

            // fallthrough
            case MissionDetailsDto.Status.COMPLETED:
            // fallthrough
            case MissionDetailsDto.Status.FINALISED:
                return 'blue';
        }
    }
}
